import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Input, message, Spin, Breadcrumb, Card } from 'antd';
import request from '../../utils/request';
import styles from './index.module.scss';
import unactivatedIcon from '../../assets/noProject.png';
import activatedIcon from '../../assets/noProject2.png'; // Using placeholder for activated icon as well for now or similar
import { useGetState } from 'ahooks';
import successIcon from '../../assets/同意.png';
import errorIcon from '../../assets/告警实心.png';
import { useSelector } from 'react-redux'

const ServiceActivation = () => {
  const [loading, setLoading] = useState(true);
  const [isActivated, setIsActivated] = useState(false);
  const [serviceInfo, setServiceInfo] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [activating, setActivating] = useState(false);
  const userInfo = useSelector((state) => state.login.userInfo)
  
  // Result Modal State
  const [resultModalVisible, setResultModalVisible] = useState(false);
  const [isActivateSuccess, setIsActivateSuccess] = useState(false);
  const [activateMsg, setActivateMsg] = useState('');

  useEffect(() => {
    fetchStatus();
  }, []);

  const fetchStatus = async () => {
    setLoading(true);
    try {
      const res = await request({
        url: 'sys/comp/serv-activate/',
        method: 'get',
        isLoading: false,
      });
      
      if (res && res.data && res.data.code === 0) {
        const data = res.data.data;
        // Check if exists is true to determine if activated
        const isActive = data.exists === true;
        setIsActivated(isActive);
        if (isActive) {
          setServiceInfo({
            ...data,
            org_name: data.co_name,
            org_code: data.co_code,
          });
        }
      } else {
        setIsActivated(false);
      }
    } catch (error) {
      console.error('Failed to fetch activation status', error);
      setIsActivated(false);
    } finally {
      setLoading(false);
    }
  };

  const handleActivate = async () => {
    try {
      const values = await form.validateFields();
      setActivating(true);
      
      const res = await request({
        url: 'sys/comp/serv-activate/',
        method: 'post',
        data: {
          api_key: values.apiKey,
          secret_key: values.secretKey,
          co_id: userInfo.co_id,
        },
        isLoading: false,
        notMsg: true,
      });

      if (res && res.data && res.data.code === 0) {
        // Success
        setIsActivateSuccess(true);
        setActivateMsg(res.data.msg || '激活成功！');
        setResultModalVisible(true);
      } else {
        // Failure
        setIsActivateSuccess(false);
        setActivateMsg((res && res.data && res.data.msg) || '激活失败！');
        setResultModalVisible(true);
      }
    } catch (error) {
      console.error('Activation failed', error);
    } finally {
      setActivating(false);
    }
  };

  const handleResultConfirm = () => {
    if (isActivateSuccess) {
        setResultModalVisible(false);
        setModalVisible(false);
        form.resetFields();
        fetchStatus();
    } else {
        setResultModalVisible(false);
    }
  };

  const showModal = () => {
    setModalVisible(true);
  };

  const InfoItem = ({ label, value }) => (
    <div className={styles.infoItem}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value || '-'}</span>
    </div>
  );

  if (loading) {
    return (
      <div className={styles.root}>
        <Spin size="large" tip="加载中..." className={styles.loading} />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Breadcrumb>
          <Breadcrumb.Item>系统管理</Breadcrumb.Item>
          <Breadcrumb.Item>服务激活</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      
      <div className={styles.content}>
        <Card bordered={false} className={styles.card}>
          <div className={styles.innerContainer}>
            <img 
              src={isActivated ? activatedIcon : unactivatedIcon} 
              className={styles.statusIcon} 
              alt="status" 
            />
            <div className={styles.mainContent}>
              <div className={`${styles.statusTitle} ${isActivated ? styles.activatedTitle : styles.unactivatedTitle}`}>
                {isActivated ? '服务已激活!' : '服务未激活!'}
              </div>
              <div className={`${styles.description} ${isActivated ? styles.descGray : styles.descRed}`}>
                如果您部署的产品包含吾道科技SaaS服务，请联系交付工程师激活。
                {!isActivated && <br />}
                如果您产品为独立部署版本，则无需激活即可使用全部功能。
              </div>

              {isActivated ? (
                <>
                  <div className={styles.infoSection}>
                    <div className={styles.infoTitle}>服务信息</div>
                    <div className={styles.infoList}>
                      <InfoItem label="服务组织名称" value={serviceInfo.org_name} />
                      <InfoItem label="服务组织编号" value={serviceInfo.org_code} />
                      <InfoItem label="API KEY" value={serviceInfo.api_key} />
                      <InfoItem label="SECRET KEY" value={serviceInfo.secret_key} />
                    </div>
                  </div>
                  <Button type="primary" onClick={showModal} className={styles.actionBtn}>更新服务信息</Button>
                </>
              ) : (
                <Button type="primary" onClick={showModal} className={styles.actionBtn}>立即激活</Button>
              )}
            </div>
          </div>
        </Card>
      </div>

      <Modal
        title="服务激活"
        visible={modalVisible}
        onOk={handleActivate}
        onCancel={() => setModalVisible(false)}
        confirmLoading={activating}
        destroyOnClose
        width={500}
        centered={true}
      >
        <p className={styles.boldText}>输入激活信息（可联系部署工程师获取）</p>
        <Form
          form={form}
          layout="vertical"
        >
          <Form.Item
            name="apiKey"
            label="API KEY"
            rules={[{ required: true, message: '请输入 API KEY' }]}
          >
            <Input placeholder="请输入 API KEY" />
          </Form.Item>
          <Form.Item
            name="secretKey"
            label="SECRET KEY"
            rules={[{ required: true, message: '请输入 SECRET KEY' }]}
          >
            <Input placeholder="请输入 SECRET KEY" />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={isActivateSuccess ? "账号激活" : "账号激活"}
        visible={resultModalVisible}
        onCancel={() => setResultModalVisible(false)}
        footer={null}
        width={400}
        destroyOnClose
        centered={true}
      >
        <div className={styles.resultModalContent}>
            <img 
                src={isActivateSuccess ? successIcon : errorIcon} 
                alt="status" 
                className={styles.resultIcon}
            />
            <div className={styles.resultTitle}>
                {isActivateSuccess ? '激活成功！' : '激活失败！'}
            </div>
            {!isActivateSuccess && (
                <div className={styles.resultMsg}>
                    {activateMsg}
                </div>
            )}
            <Button type="primary" onClick={handleResultConfirm} className={isActivateSuccess ? styles.resultBtnSuccess : styles.resultBtnError}>
                确定
            </Button>
        </div>
      </Modal>
    </div>
  );
};

export default ServiceActivation;
